// extracted by mini-css-extract-plugin
export default {"tabWrapper":"tabWrapper_tabWrapper__C78+e","hideTab":"tabWrapper_hideTab__nVwTw"};